<ng-container>
	<h1 class="landing-title">Select login method</h1>

  <div class="landing-container">
    <div class="method-container">
      <h2 class="method-title">Login with Aruba Bank App</h2>
      <ng-container *ngIf="isDesktop">
        <div class="helpsteps-container">
          <div class="list-numbered">
            <ul class="list-numbered fixed-view">
              <li>
                <div>
                  <div class="circle blue">
                    <span>1</span>
                  </div>
                </div>
                <div>
                  <span>Open the Aruba Bank App</span>
                  <span class="hard-token icon"></span>
                </div>
              </li>
              <li>
                <div>
                  <div class="circle blue">
                    <span>2</span>
                  </div>
                </div>
                <div>
                  <div>Tap on the QR-code icon in the left corner</div>
                  <div class="app-image"></div>
                </div>
              </li>
              <li>
                <div>
                  <div class="circle blue">
                    <span>3</span>
                  </div>
                </div>
                <div>
                  <span>Scan the QR-code and approve payment</span>
                  <div class="qr-container" [ngClass]="{ 'retry-qr': retryQR, 'hide-qr': isLoading }">
                    <img [src]="qrCodeImage" class="qr-code-image" />
                    <button class="btn-retry-qr" (click)="getQRCode()" [disabled]="isLoading">
                      <img [src]="refreshImg" />
                    </button>
                    <p>Click to generate a new QR code</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isDesktop">
        <div class="mobile-image"></div>
        <p>Press the button below to open the app and approve your login to Aruba Bank Online.</p>
        <button class="btn btn-primary" (click)="openApp()">Log in with the Aruba Bank App</button>
      </ng-container>
    </div>
    <div class="method-container">
      <h2 class="method-title">Login with token</h2>

			<div class="helpsteps-container">
				<div class="list-numbered">
					<ul class="list-numbered fixed-view">
						<li>
							<div>
								<div class="circle blue">
									<span>1</span>
								</div>
							</div>
							<div>
								<div>Click on below button to login to Aruba Bank Online</div>
							</div>
						</li>
						<li>
							<div>
								<div class="circle blue">
									<span>2</span>
								</div>
							</div>
							<div>
								<div>Follow the steps to approve payment</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<button class="btn btn-outline-primary btn-step"  (click)="loginWithToken.emit()">
				<span >Continue to Aruba Bank Online</span>
			</button>
		</div>
	</div>
</ng-container>